module.exports = __webpack_public_path__ + "static/img/new1.f821c86.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new1.jpeg
// module id = t2DL
// module chunks = 0